export const getDataFromDetailsSectionCache = (sectionId, array = []) => {
  for (const arr of array) {
    if (arr && Array.isArray(arr)) {
      const dataObj = arr.find((item) => item && item.sectionId === sectionId);
      if (dataObj) {
        return dataObj;
      }
    }
  }
  return null; // If sectionId is not found or array is invalid
};
